import { render } from "./Live.vue?vue&type=template&id=3c9a8ecc&scoped=true&ts=true"
import script from "./Live.vue?vue&type=script&setup=true&lang=ts"
export * from "./Live.vue?vue&type=script&setup=true&lang=ts"

import "./Live.vue?vue&type=style&index=0&id=3c9a8ecc&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9a8ecc"],['__file',"src/components/player/Live.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c9a8ecc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c9a8ecc', __exports__)) {
    console.log('reload')
    api.reload('3c9a8ecc', __exports__)
  }
  
  module.hot.accept("./Live.vue?vue&type=template&id=3c9a8ecc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3c9a8ecc', render)
  })

}


export default __exports__